export default __webpack_public_path__ + "static/business-signin-04bc78c32afbd182844feaf9b7ba0c62.jpg";